import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_133: FaireProductEntity = {
  token: "legacy_prod_abbott-133",
  type: "product",
  name: "Blue & Ivory Printed Floor Rug",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2c4e41b1a590b183c6a476457bcced03397d120d14b6d4cd6aa1653d1d88e5af.jpeg",
  priceDollars: 89,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
